import { render, staticRenderFns } from "./HeadlineWithLine.vue?vue&type=template&id=0499e9c4&scoped=true&"
import script from "./HeadlineWithLine.vue?vue&type=script&lang=js&"
export * from "./HeadlineWithLine.vue?vue&type=script&lang=js&"
import style0 from "./HeadlineWithLine.vue?vue&type=style&index=0&id=0499e9c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0499e9c4",
  null
  
)

export default component.exports